import { t } from '@/plugins/i18n'
import { ref, nextTick } from 'vue'
import {
  productSkuEdit
} from '@/apis/inShipping'
import { ElMessage } from 'element-plus'

export default (form: any, formRef:any) => {
  const getProductSkuList = (val: never[]) => {
    const list = (val || []).map((e: any) => ({ ...e, deliveryNums: e.deliverNum ?? (form.allIncludeFlag === 1 ? e.allIncludeUseable : e.useable) }))
    const finalList = [...form.deliverTaskDetails]
    list.forEach((item: any) => {
      const findItem = finalList.find((v: any) => v.productSku === item.productSku)
      if (findItem) {
        findItem.deliveryNums = item.deliveryNums
      } else {
        finalList.push(item)
      }
    })
    form.deliverTaskDetails = finalList
    nextTick(() => {
      // 重新校验 form.deliverTaskDetails 里的 deliveryNums
      if (formRef.value) {
        // 遍历 deliverTaskDetails 中的每个元素进行验证
        form.deliverTaskDetails.forEach((_:any, index:number) => {
          formRef.value.validateField(`deliverTaskDetails.${index}.deliveryNums`, (errors: any) => {
            if (errors) {
              // 处理校验错误
              console.log('校验出错:', errors)
            } else {
              console.log('校验通过')
            }
          })
        })
      }
    })
  }

  const addProductVisible = ref(false)
  const openAddProductVisible = () => {
    addProductVisible.value = true
  }

  const STableRef = ref()

  const productSelection = ref([])
  const handleSelection = (val: any) => {
    productSelection.value = val
  }

  const delMoreRow = () => {
    productSelection.value.forEach((p: any) => {
      const idx = form.deliverTaskDetails.findIndex((e: any) => e.productSku === p.productSku)
      form.deliverTaskDetails.splice(idx, 1)
    })
    STableRef.value.clearSelection()
  }
  const delRow = (productSku: any) => {
    const idx = form.deliverTaskDetails.findIndex((e: any) => e.productSku === productSku)
    form.deliverTaskDetails.splice(idx, 1)
    STableRef.value.clearSelection()
  }

  const saveoverseaProducSku = (row: any) => {
    const { overseaProductSku, shopProductSku } = row
    row.loading = true
    productSkuEdit({ overseaProducSku: overseaProductSku, shopProductSku }).then(() => {
      ElMessage.success(t('保存成功'))
    }).finally(() => {
      row.loading = false
      row.showAverseaProductSku = false
    })
  }

  return {
    STableRef,
    getProductSkuList,
    addProductVisible,
    openAddProductVisible,
    handleSelection,
    delMoreRow,
    delRow,
    saveoverseaProducSku
  }
}
